<script lang="ts">
  let { lines = 3 }: { lines?: number } = $props();
</script>

<div class="skeleton-group">
  {#each Array(lines) as _, i}
    <div class="skeleton" style="width: {i === lines - 1 ? '60%' : '100%'}; height: 1rem;"></div>
  {/each}
</div>

<style>
  .skeleton-group {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
</style>
